export default "__VITE_ASSET__CAgZwutH__"